// ساختار منو بر اساس نقش. roles: چه نقش‌هایی ببینند.
// roleTitles: عنوان مخصوص یک نقش (اگر نبود، همان title نمایش داده می‌شود)
const ALL = ["admin", "staff", "manager"];

export const MENU = [
  {
    key: "home",
    title: "داشبورد",
    icon: "fa-solid fa-house",
    path: "/",
    end: true,
    roles: ALL,
  },
  {
    key: "base",
    title: "اطلاعات پایه",
    icon: "fa-solid fa-layer-group",
    roles: ["admin"],
    children: [
      {
        key: "org",
        title: "اطلاعات اداره",
        icon: "fa-regular fa-building",
        path: "/base/org",
      },
      {
        key: "positions",
        title: "سمت‌ها",
        icon: "fa-solid fa-id-badge",
        path: "/base/positions",
      },
      {
        key: "employees",
        title: "کارکنان",
        icon: "fa-solid fa-users",
        path: "/base/employees",
      },
      {
        key: "shifts",
        title: "برنامه شیفت کاری",
        icon: "fa-regular fa-calendar-days",
        path: "/base/shifts",
      },
      {
        key: "jobs",
        title: "شرح وظایف",
        icon: "fa-solid fa-list-check",
        path: "/base/jobs",
      },
    ],
  },
  {
    key: "tasks",
    title: "وظایف روزانه",
    icon: "fa-solid fa-clipboard-check",
    path: "/tasks",
    roles: ["admin", "staff"],
  },
  {
    key: "assigned-tasks",
    title: "وظایف محوله",
    icon: "fa-solid fa-clipboard-list",
    path: "/assigned-tasks",
    roles: ["staff", "manager"],
  },
  {
    key: "missions",
    title: "ماموریت‌ها",
    icon: "fa-solid fa-paper-plane",
    path: "/missions",
    roles: ["admin", "manager", "staff"],
  },
  {
    key: "directives",
    title: "ابلاغ مدیر بندر",
    roleTitles: { manager: "ابلاغ به شیفت آتش‌نشانی" },
    icon: "fa-solid fa-bullhorn",
    path: "/directives",
    roles: ALL,
  },
  {
    key: "manager-inbox",
    title: "منتظر تأیید مدیر بندر",
    icon: "fa-solid fa-hourglass-half",
    path: "/manager-inbox",
    roles: ["manager"],
  },
  {
    key: "manager-letters",
    title: "نامه‌های مدیر بندر",
    roleTitles: { manager: "ابلاغ به مدیر ایمنی" },
    icon: "fa-regular fa-envelope-open",
    path: "/manager-letters",
    roles: ALL,
  },
  {
    key: "pledges",
    title: "تعهدنامه‌ها",
    icon: "fa-solid fa-file-signature",
    roles: ["admin", "staff", "manager"],
    children: [
      {
        key: "p-repair",
        title: "تعهدنامه تعمیرات جزئی",
        icon: "fa-solid fa-screwdriver-wrench",
        path: "/pledges/repair",
      },
      {
        key: "p-crane",
        title: "تعهدنامه جرثقیل",
        icon: "fa-solid fa-truck-ramp-box",
        path: "/pledges/crane",
      },
      {
        key: "p-electricity",
        title: "تعهدنامه استفاده از برق",
        icon: "fa-solid fa-bolt",
        path: "/pledges/electricity",
      },
    ],
  },
  {
    key: "incidents",
    title: "ثبت حوادث",
    roleTitles: { manager: "حوادث" },
    icon: "fa-solid fa-triangle-exclamation",
    path: "/incidents",
    roles: ["admin", "staff", "manager"],
  },
  {
    key: "violations",
    title: "ثبت تخلف",
    roleTitles: { admin: "تخلفات", manager: "تخلفات" },
    icon: "fa-solid fa-gavel",
    path: "/violations",
    roles: ["admin", "staff", "manager"],
  },
  {
    key: "requests",
    title: "درخواست‌ها",
    icon: "fa-solid fa-inbox",
    roles: ["admin", "staff", "manager"],
    children: [
      {
        key: "r-personal",
        title: "درخواست فردی",
        icon: "fa-regular fa-user",
        path: "/requests/personal",
      },
      {
        key: "r-org",
        title: "درخواست سازمانی",
        icon: "fa-regular fa-building",
        path: "/requests/org",
      },
      {
        key: "leave",
        title: "تأیید مرخصی",
        icon: "fa-solid fa-user-check",
        path: "/leave-approvals",
        roles: ALL,
      },
    ],
  },

  {
    key: "reports",
    title: "گزارش‌ها",
    icon: "fa-solid fa-chart-column",
    path: "/reports",
    roles: ALL,
  },
  {
    key: "letters",
    title: "نامه‌نگاری",
    icon: "fa-regular fa-envelope",
    path: "/letters",
    roles: ["admin"],
  },
  {
    key: "equipment",
    title: "تجهیزات",
    icon: "fa-solid fa-fire-extinguisher",
    path: "/equipment",
    roles: ALL,
  },
  {
    key: "warehouse",
    title: "انبار ایمنی",
    icon: "fa-solid fa-warehouse",
    path: "/warehouse",
    roles: ALL,
  },
  {
    key: "property",
    title: "اموال",
    icon: "fa-solid fa-stamp",
    path: "/property",
    roles: ALL,
  },
  {
    key: "expenses",
    title: "هزینه‌ها",
    icon: "fa-solid fa-coins",
    path: "/expenses",
    roles: ["admin", "staff", "manager"],
  },
  {
    key: "my-shifts",
    title: "شیفت کاری من",
    icon: "fa-regular fa-calendar-days",
    path: "/my-shifts",
    roles: ["staff"],
  },
  {
    key: "settings",
    title: "تنظیمات",
    icon: "fa-solid fa-gear",
    path: "/settings",
    roles: ALL,
  },
];

const titleFor = (item, role) => item.roleTitles?.[role] ?? item.title;

export const menuFor = (role) =>
  MENU.filter((m) => m.roles.includes(role)).map((m) => ({
    ...m,
    title: titleFor(m, role),
    children: m.children
      ?.filter((c) => !c.roles || c.roles.includes(role))
      .map((c) => ({ ...c, title: titleFor(c, role) })),
  }));
export const allPaths = (role) =>
  menuFor(role).flatMap((m) =>
    m.children ? m.children.map((c) => c.path) : [m.path],
  );

